// import './flickity.pkgd'; // DEPRECATED, USE NPM FLICKITY PACKAGES INSTEAD
import './modernizr-custom';
import './jquery.cookie';
